export const categories = [
  {
    id: 'all',
    title: 'All',
    icon: 'IconFilter',
    count: 753,
  },
  { id: 'asphalt', title: 'Asphalt', icon: 'IconRoad', count: 6 },
  { id: 'concrete', title: 'Concrete', icon: 'IconBuildingSkyscraper', count: 19 },
  { id: 'fabric', title: 'Fabric', icon: 'IconArmchair', count: 77 },
  { id: 'floor', title: 'Floor', icon: 'IconStairs', count: 90 },
  { id: 'gem', title: 'Gem', icon: 'IconDiamond', count: 11 },
  { id: 'glass', title: 'Glass', icon: 'IconGlass', count: 18 },
  { id: 'ground', title: 'Ground', icon: 'IconWorld', count: 85 },
  { id: 'leather', title: 'Leather', icon: 'IconBriefcase', count: 16 },
  { id: 'metal', title: 'Metal', icon: 'IconToolsKitchen2', count: 41 },
  { id: 'misc', title: 'Misc', icon: 'IconDeviceGamepad2', count: 38 },
  { id: 'organic', title: 'Organic', icon: 'IconApple', count: 21 },
  { id: 'plastic', title: 'Plastic', icon: 'IconBottle', count: 27 },
  { id: 'rock', title: 'Rock', icon: 'IconMountain', count: 26 },
  { id: 'roof', title: 'Roof', icon: 'IconHome2', count: 38 },
  { id: 'sand', title: 'Sand', icon: 'IconBeach', count: 8 },
  { id: 'sci-fi', title: 'Sci-Fi', icon: 'IconUfo', count: 37 },
  { id: 'wall', title: 'Wall', icon: 'IconBuildingArch', count: 118 },
  { id: 'wood', title: 'Wood', icon: 'IconTree', count: 23 },
  { id: 'stone', title: 'Stone', icon: 'IconMountain', count: 23 },
  { id: 'vegetation', title: 'Vegetation', icon: 'IconFlower', count: 31 },
];
